var map = {
	"./aboutFoot.png": 7925,
	"./aboutTop.png": 9012,
	"./biaoti.png": 8210,
	"./dangan.png": 2725,
	"./ditu.png": 5740,
	"./footleft.png": 131,
	"./footright1.png": 207,
	"./footright2.png": 7748,
	"./guanggao.png": 5563,
	"./logo.png": 3153,
	"./xiaofang.png": 9035
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;